import React, { useState } from "react";
import { Link, Typography, makeStyles, Button, Menu, MenuItem, useTheme, Box } from "@mui/material"; 
import classess from "./businessCategoryList.styles"
import { BusinessCategory } from "../../../types";

interface Props {
  categories: BusinessCategory[];
  selectedBusinessCategory: BusinessCategory | null;
  onSelect: (businessCategory: BusinessCategory) => void;
} 

const BusinessCategoryList: React.FC<Props> = ({ categories, selectedBusinessCategory, onSelect }) => {

  const theme = useTheme();
  const styles = classess(theme);

  const [showMore, setShowMore] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState<null | HTMLElement>(null);
  const visiblebusinessCategories = showMore ? categories : categories?.slice(0, 5);
  const hasMore = categories?.length > 5;

  const handleMoreClick = (bookingType: React.MouseEvent<HTMLElement>) => {
    setMoreMenuAnchorEl(bookingType.currentTarget);
  };

  const handleMoreClose = () => {
    setMoreMenuAnchorEl(null);
  };

  const handleMoreSelect = (businessCategory: BusinessCategory) => {
    handleMoreClose();
    onSelect(businessCategory);
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.businessCategoryList}>
        {visiblebusinessCategories?.map((businessCategory: any) => (
          <Link
            key={businessCategory.id}
            component="button"
            variant="body1"
            color={styles.businessCategoryList.color}
            onClick={() => onSelect(businessCategory)}
            sx={styles.businessCategoryButton}
            underline="none"
          >
            {businessCategory.name}
          </Link>
        ))}
        {hasMore && (
          <Button onClick={handleMoreClick} sx={styles.moreButton}>
            <Typography variant="body1">More</Typography>
          </Button>
        )}
        <Menu
          id="more-menu"
          anchorEl={moreMenuAnchorEl}
          keepMounted
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMoreClose}
        >
          {categories?.slice(5).map((businessCategory: any, key) => (
            <MenuItem
              key={businessCategory.id}
              onClick={() => handleMoreSelect(businessCategory)}
            >
              {businessCategory.name}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};

export default BusinessCategoryList;
